import styled from "@emotion/styled";
import {Text} from "@pg-design/text";

export const NavigationText = styled(Text)`
    font-size: 1.2rem !important;
    line-height: 1.6rem !important;
`;
